(function () {
    'use strict';

    angular
        .module('app')
        .controller('HeaderController', HeaderController);

    HeaderController.$inject = ['$rootScope', '$scope', 'authenticator', '$state', 'localization', '$cookies', '$http', '$translate', 'cache'];

    function HeaderController($rootScope, $scope, authenticator, $state, localization, $cookies, $http, $translate, cache) {
        var vm = this;
        vm.showMenu = showMenu;
        vm.menuShow = false;
        vm.showMenu = showMenu;
        vm.$onInit = init;
        vm.setLanguage = setLanguage;
        vm.setLocation = setLocation;
        vm.goToProfile = goToProfile;
        vm.closeMenu = closeMenu;
        vm.state = state;
        vm.language = localization.getLanguage();
        vm.showLanguageSelect = false;
        vm.showLocationSelect = false;
        vm.logout = logout;

        function init() {
            vm.loggedIn = checkLoggedIn();
            vm.isLight = authenticator.isLight();
            localization.getLocation().then(function(response) {
                vm.location = response;
            });
        }

        function state() {
            return $state.current.name;
        }

        function goToProfile() {
            cache.clear();
            if($state.current.name == "member") {
                location.reload();
            }
            $state.go('member');
        }

        function closeMenu() {
            vm.menuShow = false;
        }

        function checkLoggedIn() { //Checks whether the current user is logged-in and changes the header based on this
            authenticator.checkLoginStatus()
                .then(function(loggedIn){
                    vm.loggedIn = loggedIn;
                    if(loggedIn && !vm.isLight) {
                        getNotifications();
                    }
                });
        }

        function getNotifications() { //Gets notifications for current user and also returns current user-slug
            $http.get('api/notifications/')
                .then(function(response) {
                    vm.notifications = response.data;
                    vm.user_avatar = 'uploads/users/'+vm.notifications.user_slug+'/1_xs.jpeg';
                    vm.user_name = vm.notifications.user_name;
                    $rootScope.notifications = vm.notifications;
                    $rootScope.user_avatar = vm.user_avatar;
                });
        }

        var deregister_toggle_menu = $scope.$on('toggle_menu', function() { //Toggles the menu-popup
            showMenu();
        });

        $scope.$on('update_notifications', function() {
            getNotifications();
        });

        $rootScope.$on('update_avatar', function() {
            vm.user_avatar = 'uploads/users/'+vm.notifications.user_slug+'/1_xs.jpeg?cb=' + Date.now();
            $scope.$applyAsync();
        });

        $scope.$on('$destroy', deregister_toggle_menu);

        var deregister_toggle_login = $scope.$on('toggle_login', function(){ //Toggles the login-popup
            showLogin();
        });

        $scope.$on('$destroy', deregister_toggle_login);

        var deregister_toggle_sign_up = $scope.$on('toggle_sign_up', function(){ //Toggles the sign-up-popup
            showSignUp();
        });

        $scope.$on('$destroy', deregister_toggle_sign_up);

        $rootScope.$on('check_login_status', function () {
            checkLoggedIn();
            vm.isLight = authenticator.isLight();
        });

        function showMenu() {
            vm.menuShow = !vm.menuShow;
        }

        function setLanguage($language) { //Sets the language cookie
            vm.language = $language;
            localization.setLanguage($language).then(function () {
                $scope.$applyAsync(function() {
                    vm.showLanguageSelect = false;
                    location.reload();
                });
            }).then(function() {
                if($language == 'sv') {
                    localization.setLocation('Sweden');
                }
                if($language == 'da_dk') {
                    localization.setLocation('Denmark');
                }
            });
        }

        function setLocation($location) { //Sets the language cookie
            vm.location = $location;
            localization.setLocation($location).then(function () {
                $scope.$applyAsync(function() {
                    vm.showLocationSelect = false;
                    location.reload();
                });
            });

        }

        function logout() {
            authenticator.logout()
                .then(function(response){
                    $rootScope.$broadcast('check_login_status');
                    $state.go('frontpage');
                });
        }
    }
})();
